import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardPage from "@pages/DashboardPage";
import LoginPage from "@pages/LoginPage";
import NotFoundPage from "@pages/NotFoundPage";
import PrivateRoute from "./PrivateRoute";

// O Dashboard121Insights (v45) gerencia internamente sua própria navegação
// entre abas e sua própria sidebar/topbar. Por isso, não há AppLayout
// envolvendo a rota principal — o componente renderiza fullscreen.
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
